<template>
  <b-nav-item-dropdown
    ref="notificationDropdownRef"
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        v-if="!showLoader"
        :badge="total"
        badge-classes="bg-primary"
        class="text-body"
        icon="BellIcon"
        size="21"
      />
      <b-spinner
        v-else
        type="grow"
        variant="secondary"
      />
    </template>

    <b-overlay
      :show="showLoader"
      rounded="sm"
    >

      <!-- Header -->
      <li class="dropdown-menu-header">
        <div class="dropdown-header d-flex">
          <h4 class="notification-title mb-0 mr-auto">
            <feather-icon
              v-if="showHowMany !== null"
              v-ripple.400="'rgba(255, 159, 67, 0.15)'"
              v-b-tooltip.hover.left.v-warning
              class="mr-25 text-warning"
              size="17"
              icon="EyeOffIcon"
              :title="`Registros limitados a ${showHowMany}, es posible que haya más notificaciones`"
            />
            Notificaciones
          </h4>
          <b-badge
            class="cursor-pointer"
            :variant="hover.buttonReload ? 'light-primary' : 'light-dark'"
            @mouseover="hover.buttonReload = true"
            @mouseleave="hover.buttonReload = false"
            @click="loadNotifications()"
          >
            <feather-icon
              icon="RepeatIcon"
              class="mr-25"
            />
            <span>Actualizar</span>
          </b-badge>
        </div>
      </li>

      <!-- Notifications -->
      <vue-perfect-scrollbar
        :settings="perfectScrollbarSettings"
        class="scrollable-container media-list scroll-area"
        tagname="li"
      >
        <!-- Lista de notificaciones -->
        <b-link
          v-for="notification in notificaciones"
          :key="notification.idNotificacion"
          :to="`/notificaciones?open=${notification.idNotificacion}`"
          @click="$refs.notificationDropdownRef.hide(true)"
        >
          <b-media>
            <template #aside>
              <b-avatar
                variant="light-secondary"
                size="35"
                class="mr-25"
              >
                <b-img
                  width="25"
                  :src="require('@/assets/images/icons/speaker.svg')"
                />
              </b-avatar>
            </template>
            <span class="font-weight-bolder media-heading d-block">
              {{ notification.titulo }}
            </span>

            <div class="d-flex justify-content-between">
              <small class="notification-text">{{ timestampToDate(notification.fecha, 'LLLL') }}</small>
              <div>
                <feather-icon
                  v-if="notification.url"
                  v-b-tooltip.hover.bottom="'Notificación con liga'"
                  class="text-dark mr-75"
                  size="11"
                  icon="LinkIcon"
                />
                <!-- Prioridad -->
                <span
                  v-b-tooltip.hover.bottom="`Prioridad ${notification.prioridad}`"
                  class="bullet bullet-sm"
                  :class="`bullet-${notificationPriority(notification.prioridad)}`"
                />
              </div>
            </div>
          </b-media>
        </b-link>

        <!-- Mensaje cuando no haya notificaciones sin leer -->
        <div
          v-if="total === 0"
          class="text-center py-1"
        >
          <b-avatar
            variant="light-secondary"
            size="65"
            class="shadow mb-1"
          >
            <b-img
              width="30"
              :src="require('@/assets/images/icons/speaker.svg')"
            />
          </b-avatar>
          <b-card-text class="m-auto w-75">
            <b>No</b> tienes notificaciones pendientes.
          </b-card-text>
        </div>
      </vue-perfect-scrollbar>

      <!-- Loader -->
      <template #overlay>
        <div class="text-center">
          <b-spinner variant="primary" />
          <p class="mt-1">
            Conectando con el servidor ...
          </p>
        </div>
      </template>

      <!-- Notification Footer -->
      <li class="dropdown-menu-footer p-0">
        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          block
          style="border-top-left-radius: 0; border-top-right-radius: 0;"
          variant="primary"
          to="/notificaciones"
          @click="$refs.notificationDropdownRef.hide(true)"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-25"
          />
          <span>Ver todo</span>
        </b-button>
      </li>
    </b-overlay>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BAvatar,
  BButton,
  BOverlay,
  BSpinner,
  BLink,
  BCardText,
  BImg,
  VBTooltip,
} from 'bootstrap-vue'
import { onBeforeMount, ref } from '@vue/composition-api'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import { timestampToDate, notificationPriority } from '@core/utils/filter'
import useNotificacion from '@/views/campus/notificacion/useNotificacion'

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BOverlay,
    BSpinner,
    BLink,
    BCardText,
    BImg,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  setup() {
    const hover = ref({ buttonReload: false })
    const {
      loadNotifications,
      notificaciones,
      total,
      showLoader,
      useShowHowMany,
      showHowMany,
    } = useNotificacion()
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    onBeforeMount(() => { useShowHowMany.value = true })

    return {
      // Config
      perfectScrollbarSettings,
      // Functions
      loadNotifications,
      // Data
      total,
      notificaciones,
      // Loader
      showLoader,
      // Flag
      hover,
      showHowMany,
      // Filter
      timestampToDate,
      notificationPriority,
    }
  },
}
</script>
